const is = (e: KeyboardEvent, key: string) => e.key === key

export const isArrowDown = (e: KeyboardEvent) => is(e, 'ArrowDown')
export const isArrowUp = (e: KeyboardEvent) => is(e, 'ArrowUp')
export const isHome = (e: KeyboardEvent) => is(e, 'Home')
export const isEnd = (e: KeyboardEvent) => is(e, 'End')
export const isEscape = (e: KeyboardEvent) => is(e, 'Escape')
export const isShift = (e: KeyboardEvent) => is(e, 'Shift')
export const isEnter = (e: KeyboardEvent) => is(e, 'Enter')
export const isSpace = (e: KeyboardEvent) => is(e, ' ')
export const isTab = (e: KeyboardEvent) => is(e, 'Tab')
